'use client';

import productDetail from "@/styles/modules/product_detail.module.scss";
import {ModalVideoFromImageBlock} from "@/app/parts/global/ModalVideoFromImage";
import VadImage from "vadimages-nextjs-image-optimizer";

export type ResourcesBlockProps = {
    title: string;
    items: ResourcesListProps[];
}

export type ResourcesType = 'modal' | 'link';

export type ResourcesListProps = {
    type: ResourcesType;
    title: string;
    imgSrc: string;
    imgWidth: number;
    imgHeight: number;
    imgAlt: string;
    idVideo?: string;
    link?: string;
    className?: string;
    channel?: "vimeo" | "youtube";
}

export function ResourcesBlock(props: ResourcesBlockProps) {
    const {title, items} = props;

    return (
        <div className={productDetail.product_resources}>
            <div className="container">
                <div className="section_header-2col">
                    <div className="title">
                        <h2 className="h2">{title}</h2>
                    </div>
                    <div className="description">
                    </div>
                </div>
                <div className={`${productDetail.product_resources_list} md:flex`}>
                    {items && items.map((item: ResourcesListProps, key) => (
                        <div key={key} className="flex-1 mb-6 md:mb-0">
                            {item.type === 'modal' &&
                                <>
                                    <ModalVideoFromImageBlock title={item.title}
                                                              imgSrc={item.imgSrc}
                                                              imgWidth={item.imgWidth}
                                                              imgHeight={item.imgHeight}
                                                              className={item.className}
                                                              imgAlt={item.imgAlt}
                                                              channel={item.channel}
                                                              video={item.idVideo ? item.idVideo : ''}
                                                              id={key}
                                    />
                                    <span>{item.title}</span>
                                </>
                            }
                            {item.type === 'link' &&
                                <div className={item.className}>
                                    {item.link != null &&
                                        <a href={item.link} target="_blank">
                                            <figure>
                                                <VadImage src={item.imgSrc} width={item.imgWidth} height={item.imgHeight} alt={item.imgAlt}/>
                                            </figure>
                                            <span className="btn-arrow-orange">{item.title}</span>
                                        </a>
                                        }
                                </div>
                            }
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}